import React from 'react';
import { Link } from 'react-router-dom';
// Images
import AboutImage from '../../assets/images/people/siv-renate-about-image.webp';
// Constants
import { CompanyName } from '../../utils/Constants';
import { BOOKING_PAGE_URL } from '../../utils/Routes';
// Components
import StatsComponent from '../stats/StatsComponent';
// Icons
import { MdDoubleArrow } from 'react-icons/md';

function HomeAboutSection() {
  return (
    <section
      className='grid min-h-screen xl:h-screen xl:max-h-screen overflow-hidden dark:text-colour2'
      aria-labelledby='home-about-heading'
      itemScope
      id='about'
      itemType='https://schema.org/Person'
    >
      {/* fixed-height row that can shrink; no outer padding */}
      <div className='grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-[1.2fr_1.8fr] py-8 px-4 xl:py-24 2xl:px-32 lg:px-16 overflow-hidden'>
        <section className='grid overflow-hidden rounded-tl-3xl rounded-tr-3xl lg:rounded-tl-3xl lg:rounded-tr-none lg:rounded-bl-3xl shadow-cardShadow dark:shadow-colour1'>
          <img
            src={AboutImage}
            alt={`${CompanyName} — about portrait`}
            loading='lazy'
            decoding='async'
            className='object-cover h-full xl:object-contain xl:h-auto'
          />
        </section>
        {/* Text */}
        <section className='grid order-1 lg:order-2 h-full'>
          <article
            aria-labelledby='home-about-heading'
            className='grid gap-y-8 h-full bg-colour1 border-l-[1px] lg:border-l-0 border-t-[1px] border-r-[1px] border-b-[1px] border-solid border-colour2 dark:border-colour3 px-6 pt-12 pb-4 lg:pt-12 lg:px-10 text-center lg:text-left shadow-cardShadow dark:shadow-colour1'
            itemProp='description'
          >
            <h3
              id='home-about-heading'
              className='text-2xl font-titleFont lg:text-3xl xl:text-4xl font-semibold lg:leading-[3rem]'
            >
              About <span itemProp='name'>{CompanyName}</span> Productions
            </h3>

            <p className='text-base lg:text-lg xl:text-xl leading-relaxed'>
              I create commercials, edit media, and offer classes with practical
              advice in body and mental wellness. My approach blends creativity
              with performance coaching to help you grow sustainably.
            </p>

            <ul className='grid list-disc list-inside gap-y-2 h-fit lg:text-xl text-center'>
              <li>Brand storytelling and content direction</li>
              <li>Media editing and post-production</li>
              <li>Workshops and private coaching</li>
            </ul>

            <div className='grid px-4 justify-center'>
              <Link
                to={BOOKING_PAGE_URL}
                className='grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
                aria-label={`Book ${CompanyName}`}
                rel='bookmark'
                title='Booking page'
              >
                <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4 lg:py-2 lg:px-8'>
                  <span>BOOK NOW</span>
                  <MdDoubleArrow className='text-xl lg:text-2xl' />
                </div>
              </Link>
            </div>
            <StatsComponent />
          </article>
        </section>
      </div>
    </section>
  );
}

export default HomeAboutSection;
